// extracted by mini-css-extract-plugin
module.exports = {"link":"IconButton_link__1h5_K","icon":"IconButton_icon__3BDxJ","moveArrow":"IconButton_moveArrow__2CaMg","column":"IconButton_column__2a0P0","button":"IconButton_button__23odC"};